(function() {
  'use strict';

  function updateSelectedCount(customSelect, filter, hiddenSelect) {
    const selectedOptions = Array.from(hiddenSelect.options).filter(opt => opt.selected);
    const countBadge = customSelect.querySelector('.filter-title span');
    
    if (countBadge) {
      countBadge.textContent = selectedOptions.length;
    }
  }

  function initCustomSelects() {
    const customSelects = document.querySelectorAll('.custom-select');
    
    if (!customSelects.length) return;

    customSelects.forEach(function(customSelect) {
      const trigger = customSelect.querySelector('.custom-select-trigger');
      const options = customSelect.querySelectorAll('.custom-select-option');
      const hiddenSelect = customSelect.querySelector('.filter-select-hidden');
      const label = customSelect.querySelector('.custom-select-label');

      if (!trigger || !hiddenSelect || !label) return;

      // Function to position dropdown
      function positionDropdown() {
        const dropdownOptions = customSelect.querySelector('.custom-select-options');
        const triggerRect = trigger.getBoundingClientRect();
        const filterForm = customSelect.closest('.collection-filters-form');
        
        let leftPosition = triggerRect.left;
        
        // Check if trigger is clipped by container scroll
        if (filterForm) {
          const containerRect = filterForm.getBoundingClientRect();
          const containerLeft = containerRect.left;
          
          // If trigger starts before container left edge
          if (triggerRect.left < containerLeft) {
            leftPosition = containerLeft;
          }
        }
        
        dropdownOptions.style.top = (triggerRect.bottom + 4) + 'px';
        dropdownOptions.style.left = leftPosition + 'px';
        dropdownOptions.style.width = 'auto';
        dropdownOptions.style.minWidth = triggerRect.width + 'px';
      }

      // Toggle dropdown
      trigger.addEventListener('click', function(e) {
        e.stopPropagation();
        
        // Close other open selects
        document.querySelectorAll('.custom-select.open').forEach(function(openSelect) {
          if (openSelect !== customSelect) {
            openSelect.classList.remove('open');
          }
        });
        
        const isOpening = !customSelect.classList.contains('open');
        
        // If opening and select is clipped, scroll it into view
        if (isOpening) {
          const filterForm = customSelect.closest('.collection-filters-form');
          if (filterForm) {
            const triggerRect = trigger.getBoundingClientRect();
            const containerRect = filterForm.getBoundingClientRect();
            
            // Check if trigger is clipped
            if (triggerRect.left < containerRect.left || triggerRect.right > containerRect.right) {
              // Scroll the select into view (align to start of container)
              customSelect.scrollIntoView({ 
                behavior: 'smooth', 
                inline: 'start', 
                block: 'nearest' 
              });
              
              // Wait for scroll to finish before opening
              setTimeout(function() {
                customSelect.classList.add('open');
                positionDropdown();
              }, 300);
              return;
            }
          }
        }
        
        customSelect.classList.toggle('open');
        
        // Position dropdown if opening
        if (isOpening) {
          positionDropdown();
        }
      });

      // Reposition dropdown on scroll
      const filterForm = customSelect.closest('.collection-filters-form');
      if (filterForm) {
        filterForm.addEventListener('scroll', function() {
          if (customSelect.classList.contains('open')) {
            positionDropdown();
          }
        });
      }

      // Reposition on window scroll and resize
      window.addEventListener('scroll', function() {
        if (customSelect.classList.contains('open')) {
          positionDropdown();
        }
      });

      window.addEventListener('resize', function() {
        if (customSelect.classList.contains('open')) {
          positionDropdown();
        }
      });

      // Handle option selection
      options.forEach(function(option) {
        const checkbox = option.querySelector('.option-checkbox');

        // Handler que ejecuta la lógica de filtro
        function handleFilterChange(triggeredByCheckbox) {
          if (option.classList.contains('disabled')) return;

          const value = option.getAttribute('data-value');

          // Si fue disparado por el div, alternar el checkbox
          if (!triggeredByCheckbox && checkbox) {
            checkbox.checked = !checkbox.checked;
          }

          // Update active state
          if (checkbox.checked) {
            option.classList.add('active');
          } else {
            option.classList.remove('active');
          }

          // Update hidden select - find matching option and toggle
          Array.from(hiddenSelect.options).forEach(function(opt) {
            if (opt.value === value) {
              opt.selected = checkbox.checked;
            }
          });

          // Trigger change event on hidden select
          const event = new Event('change', { bubbles: true });
          hiddenSelect.dispatchEvent(event);

          // Update label to show count of selected items
          updateSelectedCount(customSelect, null, hiddenSelect);

          // Submit form automatically to update filters
          const form = customSelect.closest('form');
          if (form) {
            // Build URL with all filter parameters
            const formData = new FormData(form);
            const params = new URLSearchParams();

            // Get all selects in the form
            const allSelects = form.querySelectorAll('.filter-select-hidden');
            allSelects.forEach(function(select) {
              const selectedOptions = Array.from(select.options).filter(opt => opt.selected);
              selectedOptions.forEach(function(opt) {
                if (opt.value) {
                  params.append(select.name, opt.value);
                }
              });
            });

            // Navigate to the filtered URL
            const baseUrl = window.location.pathname;
            const queryString = params.toString();
            window.location.href = queryString ? baseUrl + '?' + queryString : baseUrl;
          }
        }

        // Click en el div
        option.addEventListener('click', function(e) {
          // Evitar doble ejecución si el click vino del checkbox
          if (e.target === checkbox) return;
          e.stopPropagation();
          handleFilterChange(false);
        });

        // Cambio en el checkbox
        if (checkbox) {
          checkbox.addEventListener('change', function(e) {
            e.stopPropagation();
            handleFilterChange(true);
          });
        }
      });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.custom-select')) {
        document.querySelectorAll('.custom-select.open').forEach(function(openSelect) {
          openSelect.classList.remove('open');
        });
      }
    });

    // Close dropdowns on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.custom-select.open').forEach(function(openSelect) {
          openSelect.classList.remove('open');
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomSelects);
  } else {
    initCustomSelects();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initCustomSelects);
  }
})();
